<template>
  <v-menu offset-y>
    <v-icon slot="activator" small class="mr-2">build</v-icon>
    <v-list>
      <v-list-tile v-for="(item, index) in items" :key="index" @click="action(item.title,items)">
        <v-dialog
            v-model="dialog"
            max-width="400"
        >
            <v-card>
                <v-card-title class="headline">Submission</v-card-title>
                <v-card-text>
                    {{ dialogText }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        flat="flat"
                        @click="dialog = false"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
const axios = require("axios");
import getSitePass from '../sitepass';

export default {
  name: "OptionsButton",
  props: {
    submissionId: {
      type: Number,
      required: true
    },
    formName: {
      type: String,
      required: true
    },
    emailAddress: {
      type: String,
      required: true
    },
    alertMessages: {
      type: String,
      required: true
    }
  },
  data: () => ({
    items: [{ title: "Send Email" }, { title: "Delete" }],
    dialog: false,
    dialogText: "",
    dialogType: "",
  }),
  methods: {
    action(title,items) {
      const sitePass = getSitePass();
      if (title === "Send Email") {
        axios
          .post(
            `${process.env.VUE_APP_backend_url}/sendEmail?sitepass=${sitePass}`,
            {
              email: this.emailAddress,
              messageBody: this.alertMessages,
              submissionId: this.submissionId,
              formName: this.formName
            }
          )
          .then(response => {
            this.dialogText = response.status = 200
              ? "Email has been sent successfully"
              : "Sorry, there has been a problem proccessing you request";
            this.dialogType = response.status = 200 ? "success" : "error";
          })
          .catch(error => {
            this.dialogText =
              "Sorry, there has been a problem proccessing you request";
            console.log(error);
            this.dialogType = "error";
          })
          .finally(() => {
            this.$emit("popUpRequest1", { dialogMessage: this.dialogText, alertType: this.dialogType, actionType: title, submissionId: this.submissionId });
          });
      }else {
        axios
          .post(
            `${process.env.VUE_APP_backend_url}/deleteErrorLogEntry?sitepass=${sitePass}`,
            {
              submissionId: this.submissionId,
              formName: this.formName
            }
          )
          .then(response => {
            this.dialogText = response.status = 200
              ? "The alert has been deleted successfully"
              : "Sorry, there has been a problem proccessing you request";
            this.dialogType = response.status = 200 ? "success" : "error";
          })
          .catch(error => {
            this.dialogText =
              "Sorry, there has been a problem proccessing you request";
            console.log(error);
            this.dialogType = "error";
          })
          .finally(() => {
            this.$emit("popUpRequest1", { dialogMessage: this.dialogText, alertType: this.dialogType, actionType: title, submissionId: this.submissionId });
          });
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/alertTableOptions.vue